module.exports = __webpack_public_path__ + "img/chevron-grabber-vertical.312494b1.svg";